import {
  EditContextProvider,
  SimpleForm,
  TextInput,
  BooleanInput,
  useEditController,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useParams } from "react-router-dom";

export const GraduationEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "graduations/crud",
    mutationMode: "pessimistic",
    id,
  });
  return (
    <EditContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Formações"
          firstPath="/#/graduations/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Formações" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <TextInput source="id" fullWidth helperText={false} disabled />
                <TextInput
                  source="name"
                  fullWidth
                  helperText={false}
                  label="Nome"
                />
                <BooleanInput
                  source="reviewed"
                  label="Revisado"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
